/**
 * EnterpriseSection — self-host / enterprise pitch with deploy terminal card.
 */
import { Icon } from "./LandingIcons";

export function EnterpriseSection() {
  return (
    <section id="enterprise" className="section">
      <div className="container">
        <div className="ent">
          <div>
            <div className="eyebrow eyebrow--accent">
              For teams &amp; enterprise
            </div>
            <h2>Bring Omni in-house. Keep it there.</h2>
            <p>
              Self-host the entire stack on your infra, behind your firewall,
              with your KMS keys. Or use our managed cloud with dedicated
              tenancy. Same product, your terms.
            </p>
            <ul className="ent__features">
              <li>
                <Icon name="server" size={16} />
                <span>Deploy on AWS, GCP, Azure, or bare metal</span>
              </li>
              <li>
                <Icon name="lock" size={16} />
                <span>Zero data egress. Your KMS, your keys.</span>
              </li>
              <li>
                <Icon name="shield" size={16} />
                <span>
                  SOC 2 · HIPAA · GDPR · audit trail built in
                </span>
              </li>
              <li>
                <Icon name="users" size={16} />
                <span>
                  SSO via SAML 2.0 / OIDC · SCIM provisioning
                </span>
              </li>
              <li>
                <Icon name="clock" size={16} />
                <span>24/7 SLA · solutions engineer on call</span>
              </li>
              <li>
                <Icon name="git" size={16} />
                <span>Versioned skills · approval workflows</span>
              </li>
            </ul>
            <div style={{ display: "flex", gap: 10 }}>
              <a
                className="btn btn--primary"
                href="mailto:omanandswami2005@gmail.com?subject=Omni%20%E2%80%94%20Demo%20request"
              >
                Book a demo <Icon name="arrow" size={14} />
              </a>
              <a
                className="btn btn--ghost"
                href="https://github.com/omanandswami2005/omni-the-real-jarvis#self-host"
                target="_blank"
                rel="noreferrer"
              >
                Self-host guide
              </a>
            </div>
          </div>
          <div className="ent__visual" aria-hidden="true">
            <span className="ln">
              <span className="acc">$</span> omni deploy --self-host
              --region=eu-west-1
            </span>
            <span className="ln info">
              {"  "}↳ pulling omni/server:0.5.0 ····· done
            </span>
            <span className="ln info">
              {"  "}↳ provisioning postgres + redis + qdrant
            </span>
            <span className="ln info">
              {"  "}↳ wiring oidc (okta · auth.acme.com)
            </span>
            <span className="ln info">
              {"  "}↳ generating SOC 2 audit hooks
            </span>
            <span className="ln info">
              {"  "}↳ running security baseline ·············· passed
            </span>
            <span className="ln">
              {"  "}
              <span className="ok">✓</span> all 12 services healthy
            </span>
            <span className="ln">
              {"  "}
              <span className="ok">✓</span> compliance: SOC 2 · GDPR · HIPAA
            </span>
            <span className="ln">
              {"  "}
              <span className="ok">✓</span> egress disabled (vpc-only mode)
            </span>
            <span className="ln" style={{ marginTop: 8 }}>
              <span className="acc">→</span> https://omni.acme.com
            </span>
            <span className="ln info" style={{ marginTop: 4 }}>
              elapsed: 4m 12s
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
